import * as d3 from "d3";

// Create a color scale based on location names (or IDs)
const baseColors = d3.schemeTableau10;

let colorScale = d3.scaleOrdinal<string, string>(baseColors);

export function setColorDomain(locations: string[]) {
  colorScale.domain(locations);
}

export function getColor(locationName: string) {
  return colorScale(locationName);
}